import React from "react";

export type StageOption = "All" | "SemiFinal" | "Final";

type StageSelectProps = {
  selectedStage: StageOption;
  setSelectedStage: React.Dispatch<React.SetStateAction<StageOption>>;
};

const StageSelect: React.FC<StageSelectProps> = ({
  selectedStage,
  setSelectedStage,
}) => {
  return (
    <div className="stage-select">
      <label>ステージ：</label>
      <select
        id="stage"
        value={selectedStage}
        onChange={(e) => setSelectedStage(e.target.value as StageOption)}
      >
        <option value="All">All</option>
        <option value="SemiFinal">SemiFinal</option>
        <option value="Final">Final</option>
      </select>
    </div>
  );
};

export default StageSelect;
